import React from 'react';
import { MsalProvider } from '@azure/msal-react';
import { AuthenticationResult, EventMessage, EventType, PublicClientApplication } from '@azure/msal-browser';
import { AuthProviderProps } from './models';
import { msalConfig } from '../../config/authConfig';


const msalInstance = new PublicClientApplication(msalConfig);
// Account selection logic is app dependent. Adjust as needed for different use cases.
const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    msalInstance.setActiveAccount(account);
  }
});

const AuthProvider = (props: AuthProviderProps) => {
  console.log('authority: ' + msalConfig.auth.authority);
  return <MsalProvider instance={msalInstance}>{props.children}</MsalProvider>;
};

export default AuthProvider;